import * as React from "react";

const SvgFadeOut = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.05881 11.2867C3.48845 11.1723 2.87369 11.3537 2.46025 11.8161C1.84329 12.5062 1.90822 13.5608 2.60528 14.1716C3.30233 14.7823 4.36755 14.7181 4.9845 14.028C5.39803 13.5654 5.50521 12.9392 5.32104 12.3925L12.3224 4.56133C12.8928 4.67587 13.5077 4.49447 13.9212 4.03196C14.5381 3.34188 14.4732 2.28732 13.7761 1.67653C13.0791 1.06574 12.0139 1.13002 11.3969 1.82011C10.9835 2.28258 10.8762 2.90875 11.0603 3.45535L4.05881 11.2867Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgFadeOut;
